module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('support.webExperiment')))]), _vm._v(" "), _c('p', [_vm._v("\n    " + _vm._s(_vm.$t('support.sorry')) + "\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('support.browsers'))
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c8423e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unsupported.vue
// module id = 178
// module chunks = 2